'use client'

import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { CSSSlider } from '@/ui/layouts/css-slider/CSSSlider.client'
import type { MarketingEventSlide_EventCardFragment } from '@gql-generated/graphql'
import { useCallback } from 'react'

type MarketingEventsSliderClientProps = {
  marketingEvents: MarketingEventSlide_EventCardFragment[]
  children: React.ReactElement[]
  creativeName: string
}

export function MarketingEventsSliderWithTracking({
  marketingEvents,
  creativeName,
  children: eventsCards,
}: MarketingEventsSliderClientProps): React.ReactNode {
  const onNewItemsVisible = useCallback(
    (fromIndex: number, toIndex: number) => {
      const visibleEvents = marketingEvents.slice(fromIndex, toIndex + 1)

      visibleEvents.forEach((event, index) =>
        pushToGtmDataLayer({
          event: 'view_promotion',
          ecommerce: {
            creative_name: creativeName,
            promotion_id: (index + fromIndex).toString(),
            promotion_name: event.title,
          },
        }),
      )
    },
    [marketingEvents, creativeName],
  )

  if (!marketingEvents.length) {
    return null
  }

  return (
    <CSSSlider
      gap="md"
      onNewItemsVisible={onNewItemsVisible}
      slidesScrolledPerArrow={{ mobile: 1, tablet: 2, desktop: 2 }}
    >
      {eventsCards}
    </CSSSlider>
  )
}
